export default [
    { type: 'debit', name: 'Debit Card' },
    { type: 'credit', name: 'Credit Card' },
    { type: 'qr', name: 'QR' },
];



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/payment/custom/ntt-types.js